export class VolumeUnitConverter {
  constructor(fromUnit, toUnit) {
    this.fromUnit = fromUnit;
    this.toUnit = toUnit;
  }

  convertPrecise(value) {
    let intermediate = this.convertToCubicMillimeter(value);
    return this.convertFromCubicMillimeter(intermediate);
  }

  // Ensure that the value is a number
  convertToCubicMillimeter(value) {
    if (value === null) {
      return null;
    }

    const intValue = parseInt(value, 10);

    switch (this.fromUnit) {
      case "CMM":
        return intValue;
      case "CCM":
        return intValue * 1000;
      case "CM":
        return intValue * 1e9;
      case "CIN":
        return intValue * 16387.1;
      case "CFT":
        return intValue * 2.832e7;
      case "CYD":
        return intValue * 7.646e8;
      default:
        return intValue;
    }
  }

  convertFromCubicMillimeter(value) {
    switch (this.toUnit) {
      case "CMM":
        return value;
      case "CCM":
        return value * 0.001;
      case "CM":
        return value * 1e-9;
      case "CIN":
        return value * 6.1024e-5;
      case "CFT":
        return value * 3.5315e-8;
      case "CYD":
        return value * 1.308e-9;
      default:
        return value;
    }
  }
}
